import React, { Component } from "react"
import { Row, Col } from "reactstrap"

class Footer extends Component {
  render() {
    return (
      <React.Fragment>
        <footer className="footer px-2">
          <div className="container-fluid d-flex">
            <Row>
              <Col >{new Date().getFullYear()} Copyright © AES Technologies | All Rights Reserved.</Col>
              
            </Row>
          </div>
        </footer>
      </React.Fragment>
    )
  }
}

export default Footer;